/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavedViewListRequest {
    getFixupPrototypeFunction() { return SavedViewListRequest.fixupPrototype; }

    static newInstance(model: Partial<SavedViewListRequest>): SavedViewListRequest {
        let obj = Object.assign(new SavedViewListRequest(), model);
        SavedViewListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavedViewListRequest>): SavedViewListRequest {
        if (!model) return null;
        return SavedViewListRequest.newInstance(<SavedViewListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavedViewListRequest) {
        if (!obj) return;

        models.SavedViewListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavedViewListRequest): boolean {
        Object.setPrototypeOf(obj, SavedViewListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.SavedViewFilter.fixupPrototype(this.filters);
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Filters for the request
     */
    filters: models.SavedViewFilter;

}
